// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_layouts_simple-layout_simple-layout_module_ts":"d0ac9b634ddf6876","src_app_main_active-deployment_active-deployment_module_ts":"5c10062ffc96f29c","src_app_main_referrals_referrals_module_ts":"44560d62a044c1fe","node_modules_quill_dist_quill_js":"09a5cbdefc7a0eb2"}[chunkId] + ".js";
};